<template>
  <div class='animated fadeIn'>
    <b-row v-if="$route.name === 'Visited Sites'">
      <b-col lg='12'>
        <b-card title="<b>Visited Sites</b> List" sub-title="">
          <b-row class="mt-4">
              <b-col lg='4' md='4'>
                <b-form-group
                  label="Period"
                  label-for="visitDateTime"
                  :label-cols="2"
                  :horizontal="true">
                  <date-picker v-model="filterBy.DateTime" range format="dd/MM/yyyy" lang="en" width="212" :not-after="filterBy.DateTimeNotAfter" placeholder=" "></date-picker>
                </b-form-group>
              </b-col>
              <b-col lg='3' md='3'>
                <b-form-group
                  label="Site"
                  label-for="site"
                  :label-cols="2"
                  :horizontal="true">
                  <b-form-select v-model="filterBy.site_uuid" :options="filterBy.facilityList">
                    <template slot="first">
                      <option :value="null">All Site</option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
            <b-col lg='2' md='2'>
              <b-button variant="success" class="btn-rounded mb-3" @click="doFilter()">
                <i class="fa fa-search"></i>
              </b-button>
            </b-col>
          </b-row>

          <c-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            :method_1="setColorStatus"
            :method_2="doBookingApproval"
            :method_3="doConfirmRejecting"
            ref="dataTable">
          </c-server-table>

        </b-card>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
    <router-view></router-view>
  </div>
</template>

<script>
import axios from 'axios'
import cServerTable from '@/views/components/cServerTable'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

// custom method

export default {
  name: 'facilityBookingIndex',
  components: {
    cServerTable,
    DatePicker
  },
  data () {
    // table config
    let config = cServerTable.methods.setTableConfig({
      columns: [
        'startTime',
        'endTime',
        'site',
        'visitedBy',
        'description',
        // 'task',
        'actionButtons3'
      ],
      options: {
        headings: {
          startTime: 'Start Time',
          endTime: 'End Time',
          visitedBy: 'Visited By',
          actionButtons3: ''
        },
        sortable: ['startTime', 'endTime'],
        uniqueKey: 'uuid',
        params: {
          start_time: this.$route.query.start_time,
          end_time: this.$route.query.end_time,
          facility_booking_status_uuid: this.$route.query.facility_booking_status_uuid,
          site_uuid: this.$route.query.site_uuid
        },
        templates: {
          startTime (h, row) {
            return row.startTime !== null ? moment(row.startTime).format(window.AppConfig.dateFormat) : '-'
          },
          endTime (h, row) {
            return row.endTime !== null ? moment(row.endTime).format(window.AppConfig.dateFormat) : '-'
          },
          site (h, row) {
            return row.site.name
          },
          task (h, row) {
            return row.task !== null ? row.task.name : '-'
          }
        }
      }
    }, 'siteVisit')

    // data returned
    return {
      apiUrl: window.AppConfig.apiUrl + 'site-visit',
      apiUrlFacility: window.AppConfig.apiUrl + 'site?limit=10000000000000000000000',
      apiUrlFacilityBookingStatus: window.AppConfig.apiUrl + 'facility-booking-status',
      // vue-table-2 config
      columns: config.columns,
      options: config.options,
      // filter var
      filterBy: {
        DateTime: window.setDefaultNull(typeof this.$route.query.start_time) === null ? null : [window.setDefaultNull(this.$route.query.start_time), window.setDefaultNull(this.$route.query.end_time)],
        facilityBookingStatusList: [],
        facility_booking_status_uuid: window.setDefaultNull(this.$route.query.facility_booking_status_uuid),
        facilityList: [],
        site_uuid: window.setDefaultNull(this.$route.query.site_uuid),
        DateTimeNotAfter: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted () {
    this.initDropdownOptions_Facility()
    // this.initDropdownOptions_FacilityBookingStatus()
  },
  methods: {
    initDropdownOptions_Facility () {
      var self = this
      axios.get(this.apiUrlFacility)
        .then(response => {
          if (response !== undefined) {
            let datas = response.data._embedded.site
            datas.sort((a, b) => parseInt(a.order) - parseInt(b.order))
            for (let i = 0; i < response.data.total_items; i++) {
              this.filterBy.facilityList.push({text: datas[i].name, value: datas[i].uuid})
            }
          }
        })
        .catch(function (error) {
          self.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              self.$alertify.error(errMsg)
            })
        })
    },
    initDropdownOptions_FacilityBookingStatus () {
      axios.get(this.apiUrlFacilityBookingStatus)
        .then(response => {
          if (response !== undefined) {
            let datas = response.data._embedded.bookingStatus
            datas.sort((a, b) => parseInt(a.order) - parseInt(b.order))
            for (let i = 0; i < response.data.total_items; i++) {
              this.filterBy.facilityBookingStatusList.push({text: datas[i].name, value: datas[i].uuid})
            }
          }
        })
        .catch(function (error) {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
        }) // .bind(this)
    },

    setColorStatus (value) {
      switch (value) {
        case 'Requested':
          return 'primary'
        case 'Rejected':
          return 'danger'
        case 'Approved':
          return 'success'
        case 'Check In':
          return 'info'
        case 'Check Out':
          return 'dark'
        case 'Cancelled':
          return 'warning'
        default:
          return 'light'
      }
    },

    doBookingApproval (row, status, note) {
      if (status === 'Rejected' && note === '') { // eslint-disable-line
        this.$alertify.error('Can\'t Update. Reject Note is Required.')
        return false
      } else {
        let listStatus = this.filterBy.facilityBookingStatusList
        let uuidStatus = null
        for (let i = 0; i < listStatus.length; i++) {
          if (listStatus[i].text === status) uuidStatus = listStatus[i].value
        }
        axios.patch(this.apiUrl + '/' + row.uuid,
          {
            facilityBookingStatus: uuidStatus,
            bookingNote: note
          }
        )
          .then(response => {
            this.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>')
            row.facilityBookingStatus = status
          })
          .catch(error => {
            this.$store.dispatch('errorMessage', error)
              .then(errMsg => {
                this.$alertify.error(errMsg)
              })
          })
      }
    },
    doConfirmRejecting (row) {
      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '',
        (evt, value) => this.doBookingApproval(row, 'Rejected', value)
      )
    },
    doFilter () {
      if (this.filterBy.DateTime !== null && this.filterBy.DateTime !== '') {
        this.options.params.start_time = moment(this.filterBy.DateTime[0]).format('YYYY-MM-DD')
        this.options.params.end_time = moment(this.filterBy.DateTime[1]).format('YYYY-MM-DD')
      } else {
        this.options.params.start_time = null
        this.options.params.end_time = null
      }
      this.options.params.site_uuid = window.setDefaultNull(this.filterBy.site_uuid)
      this.options.params.facility_booking_status_uuid = window.setDefaultNull(this.filterBy.facility_booking_status_uuid)
      this.$refs.dataTable.options.params = this.options.params
      this.$refs.dataTable.setTableDatas()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/booking-ms/Index.vue